<h2>Form Controls</h2>
<form #heroForm="ngForm">

    <strong class="label-example">Checkbox - default with label</strong>
    <div class="example">
        <dodo-checkbox [settings]="demoElementsSettings.checkBox"></dodo-checkbox>
    </div>

    <strong class="label-example">Checkbox - with label on the left</strong>
    <div class="example">
        <dodo-checkbox [settings]="demoElementsSettings.checkBoxLabelLeft"></dodo-checkbox>
    </div>

    <h3>Checkbox (slide toggle / switch)</h3>

    <strong class="label-example">With no label</strong>
    <div class="example">
        <dodo-checkbox [settings]="demoElementsSettings.slideToggleWithNoLabel"></dodo-checkbox>
    </div>

    <strong class="label-example">With label</strong>
    <div class="example">
        <dodo-checkbox [settings]="demoElementsSettings.slideToggleWithLabel"></dodo-checkbox>
    </div>

    <strong class="label-example">Label on the left</strong>
    <div class="example">
        <dodo-checkbox [settings]="demoElementsSettings.slideToggleWithLabelBefore"></dodo-checkbox>
    </div>

    <h3>Radio button</h3>

    <strong class="label-example">Radio Button</strong>
    <div class="example">
        <dodo-radio-button [settings]="demoElementsSettings.radioButton"></dodo-radio-button>
    </div>

</form>

<p></p>
<p></p>
